import { EPlayerType } from '@streaming/mouflon-utils';

export enum EWatchDogEvent {
  ALIVE_PLAYER = 'alivePlayer',
  ANOTHER_ACTIVE_PLAYER = 'anotherActivePlayer',
}

export interface IWatchDogEventsMap {
  [EWatchDogEvent.ALIVE_PLAYER]: { playerType: EPlayerType };
  [EWatchDogEvent.ANOTHER_ACTIVE_PLAYER]: { wrongPlayer: EPlayerType };
}

export type TWatchDogsEventsPayload<T extends keyof IWatchDogEventsMap> = IWatchDogEventsMap[T];
